<!-- 

-->

<script>
import { SysVars } from '../main';
import Vue from 'vue';

export default {
    props: {
        obj: { type: Object },
    },

    data () {
        return {
          errorMessage: '',

          envioobj: { 
              descricao: '', 
              prazoenvio: null,
              adicionacusto: false,
              taxaentrega: 0,
              restringepeso: false,
              pesomaximo: 0,
              pesominimo: 0,
              retringevalor: false,
              totalmaximo: 0,
              totalminimo: 0,
          },

        }
    },

    computed: {
        title: function () {
            if (this.obj)
                return 'Editar forma de envio'
            else
                return 'Adicionar forma de envio'
        }
    },

    filters: {

    },

    methods: {

        closeForm () {
            this.$emit('closeform')
        },

        validarDados () {

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.handleConfirmar()
                }
            })

        },

        handleConfirmar () {
            if (!this.envioobj.adicionacusto)
              this.envioobj.taxaentrega = 0
            if (!this.envioobj.restricaopeso) {
              this.envioobj.pesomaximo = null
              this.envioobj.pesominimo = null
            }
            if (!this.envioobj.restricaovalor) {
              this.envioobj.valormaximo = null
              this.envioobj.valorminimo = null
            }
            this.$emit('confirma', this.envioobj)
        }

    },

    watch: {

    },

    mounted () {
        this.$nextTick(function () {
            this.$refs.descricao.focus()
        })
    },

    created () {
      if (this.obj){
        this.envioobj = {...this.obj}
      }
      console.log(this.envioobj)
    }

}

</script>

<template>
  <transition>
    <div id="mymodal" class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container nb-email-container" style="width: 600px; max-width: 100%">
          <div class="nb-modal-header">
            <h4 class="def-title">{{ title }}</h4>
            <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="nb-modal-scrollable-body">
            <div class="row">
                <form-field ref="descricao" v-model="envioobj.descricao" case="normal" type="text" col="12" label="Descrição desta opção de envio"
                    name="descricao" :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="row">
                <form-field ref="prazoenvio" v-model="envioobj.prazoenvio" case="normal" type="text" col="12" label="Prazo de envio (exemplo 1 à 2 dias úteis)"
                    name="prazoenvio" :v-errors="errors" v-validate="{}"></form-field>
            </div>
            <div class="row">
              <div class="col-md-12 mb-2">
                  <label class="lbl-edit">                    
                      <input type="checkbox" v-model="envioobj.adicionacusto"> Adicionar taxa de envio desta forma de entrega
                  </label>
              </div>
              <form-field v-if="envioobj.adicionacusto" v-model="envioobj.taxaentrega" type="value" :precision="2" col="3" label="Taxa de envio"
                  name="taxaentrega" :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="row">
              <div class="col-md-12 mb-2">
                  <label class="lbl-edit">                    
                      <input type="checkbox" v-model="envioobj.restricaopeso"> Restringir opção de envio pelo peso da compra 
                  </label>
              </div>
            </div>
            <div class="row" v-if="envioobj.restricaopeso">
              <form-field v-model="envioobj.pesominimo" type="value" :precision="2" col="3" label="Peso mínimo"
                  name="pesominimo" :v-errors="errors" v-validate="{ required: false }"></form-field>
              <form-field v-model="envioobj.pesomaximo" type="value" :precision="2" col="3" label="Peso máximo"
                  name="pesomaximo" :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="row">
              <div class="col-md-12 mb-2">
                  <label class="lbl-edit">                    
                      <input type="checkbox" v-model="envioobj.restricaovalor"> Restringir opção de envio pelo total da compra
                  </label>
              </div>
            </div>
            <div class="row" v-if="envioobj.restricaovalor">
              <form-field v-model="envioobj.valorminimo" type="value" :precision="2" col="3" label="Valor mínimo"
                  name="valorminimo" :v-errors="errors" v-validate="{ required: false }"></form-field>
              <form-field v-model="envioobj.valormaximo" type="value" :precision="2" col="3" label="Valor máximo"
                  name="valormaximo" :v-errors="errors" v-validate="{ required: true }"></form-field>
            </div>
            <div class="nb-modal-scrollable-footer">
                <v-button ref="btnConfirm" label="Ok" title="" :nb-btdef="true" @click="validarDados"></v-button>
                <v-button ref="btnClose" label="Cancelar" title="" @click="closeForm"></v-button>
            </div>
          </div>
      </div>
    </div>
  </transition>
</template>

<style>


</style>



// WEBPACK FOOTER //
// src/forms-loja/config-formasenvio-form-loja.vue